<template>
<v-app>
    <similar-ads></similar-ads>
</v-app>
</template>

<script>
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
export default {
    name: "mainSimilar",
    components: {SimilarAds}
}
</script>

<style scoped>

</style>